import apiFetch from "../token-guard/apiFetch";

export async function loadDestination(
  destination_ids: string[],
  language: string
) {
  const req = {
    destination_ids,
    language,
  };
  try {
    const response = await apiFetch(`/api/search/destination`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await response;

    if (data.length > 0) {
      const transformedData = data.map((item: any) => ({
        label: item.NAME,
        value: item.HOTEL_ID ?? item.ID,
        countryCode: item.COUNTRY_CODE,
        country: item.COUNTRY_NAME,
        isProperty: item.HOTEL_ID ? true : false,
      }));

      return { options: transformedData };
    }
      return { options: [] };
  } catch (error) {
    console.error("Error loading options:", error);
    return { options: [] };
  }
}
